import { Bar, BarChart, Tooltip, XAxis, YAxis } from 'recharts'
import { Typography, makeStyles } from '@material-ui/core'

import React from 'react'

interface ITransitionStrategies {
  column: number
  edgesToCenter: number
  reverseColumn: number
  default: number
}

const useTooltipStyles = makeStyles({
  root: {
    backgroundColor: '#000',
    padding: 14
  }
})

export const CustomTooltip = ({ active, payload }: any) => {
  const classes = useTooltipStyles()

  if (active && payload && payload.length) {
    return (
      <div className={classes.root}>
        <Typography>{`${payload[0].value.toLocaleString()} Boards`}</Typography>
      </div>
    )
  }

  return null
}

export const TransitionStrategies = (props: ITransitionStrategies) => {
  return (
    <BarChart
      width={1240}
      height={400}
      layout='vertical'
      data={[
        {
          name: 'Classic',
          value: props.default,
          fill: 'rgba(255, 117, 0, 0.5)'
        },
        {
          name: 'Wave',
          value: props.column,
          fill: 'rgba(255, 117, 0, 0.5)'
        },
        {
          name: 'Curtain',
          value: props.edgesToCenter,
          fill: 'rgba(255, 117, 0, 0.5)'
        },
        {
          name: 'Drift',
          value: props.reverseColumn,
          fill: 'rgba(255, 117, 0, 0.5)'
        }
      ]}>
      <YAxis dataKey='name' type='category' />
      <XAxis type='number' />
      <Bar dataKey='value' />
      <Tooltip cursor={{ fill: 'rgba(0,0,0,0.3)' }} content={CustomTooltip} />
    </BarChart>
  )
}
